<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      headerIsShow: false
    };
  },
  mounted () {
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
  },
  methods: {}
};
</script>

<style>
body {
  background-color: #fff;
}
#app {
  max-width: 1024px;
  padding: 0px 0px 50px 0px;
  /* height: 100%; */
}
.mint-indicator-wrapper {
  z-index: 99999;
}
.mint-indicator-mask {
  z-index: 99999;
  opacity: 0.5;
  background: #000;
}
.mint-toast {
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue